import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {EventService} from '../../../../core/services/event.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'guest-event',
    templateUrl: './guestEvent.component.html',
    styleUrls: ['./guestEvent.component.scss'],
    standalone: false
})

export class GuestEventComponent implements OnInit {
  guestsRows = [];
  choosenIds = [];
  chooseRequired = [];
  individualsCheckbox = [];
  index = 0;
  terms = '';
  rules = '';
  freeText = '';
  disableAll = false;
  textRows = [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 14, 15, 16, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32, 36, 38, 39, 41];
  titleComments: any = {};
  constructor(public dialogRef: MatDialogRef<GuestEventComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any, public eventService: EventService,
              public toastr: ToastrService, private translateService: TranslateService) {
      console.log(data);
      if (this.data.eventData && this.data.eventData.guestIndividual) {
        this.data.individuals = this.data.eventData.guestIndividual;
      }
    if (this.data.eventData.guestData && this.data.eventData.guestData.length) {
      this.data.choosenIds = this.data.eventData.guestData.toString().split(',').map(el => +el);
    }
    if (this.data.eventData.requiredGF && this.data.eventData.requiredGF.length) {
      this.data.requiredGF = this.data.eventData.requiredGF.toString().split(',').map(el => +el);
    }
    if (this.data.eventData.titleComments && this.data.eventData.titleComments.length) {
      this.data.titleComments = JSON.parse(this.data.eventData.titleComments);
    } else {
      this.data.titleComments = {};
    }
  }

  ngOnInit() {
    this.getGuestsInfo();
    if (this.data.individuals) {
      if (!this.isJSONObjectOrArray(this.data.individuals)) {
        let arr = this.data.individuals.split(',');
        if (arr.length) {
          arr.forEach(el => {
            this.individualsCheckbox.push({
              id: Date.now().toString(36) + Math.random().toString(36).substr(2),
              approve: true,
              value: el,
              type: 'checkbox',
            });
          });
        }
      } else {
        let arr = JSON.parse(this.data.individuals);
        if (arr.length) {
          this.individualsCheckbox = arr;
        }
      }
    }
    if (this.data.hasOwnProperty('disableAll')) {
      this.disableAll = this.data.disableAll;
    }
    this.terms = this.data?.eventData?.terms;
    this.rules = this.data?.eventData?.rules;
    this.freeText = this.data?.eventData?.freeText;
    if (this.data.requiredGF && this.data.requiredGF.length) {
      this.chooseRequired = this.data.requiredGF;
    }
    this.titleComments = this.data.titleComments;
    console.log(this.titleComments);
  }

  isJSONObjectOrArray(str) {
    try {
      const parsed = JSON.parse(str);
      return typeof parsed === 'object' && parsed !== null;
    } catch {
      return false;
    }
  }

  getGuestsInfo() {
    this.eventService.getRowsForGuestEvent().subscribe((res: any) => {
      let rowObject = {};
      let rowArrays = [];
      if (res) {
        res.forEach((el: any) => {
          if (this.data && this.data.choosenIds && this.data.choosenIds.length) {
            if (this.data.choosenIds.indexOf(+el.id) !== -1) {
              el.checked = true;
              this.choosenIds.push(+el.id);
            }
          } else {
            // this.choosenIds.push(+el.id);
            el.checked = false;
          }
          if (!rowObject[el.titleId + '-' + el.title]) {
            rowObject[el.titleId + '-' + el.title] = [];
            rowObject[el.titleId + '-' + el.title].push(el);
          } else {
            rowObject[el.titleId + '-' + el.title].push(el);
          }
        });
        let keys = Object.keys(rowObject);
        keys.forEach((k: any) => {
          rowArrays.push({
            title: k.split('-')[1],
            row: rowObject[k]
          });
        });
        this.guestsRows = rowArrays;
      }
    });
  }

  changeRows(id, e) {
    if (e.checked) {
      this.choosenIds.push(+id);
    } else {
      const index = this.choosenIds.indexOf(+id);
      if (index !== -1) {
        this.choosenIds.splice(index , 1);
      }
    }
  }

  changeRequired(id, e) {
    if (e.checked) {
      this.chooseRequired.push(+id);
    } else {
      const index = this.chooseRequired.indexOf(+id);
      if (index !== -1) {
        this.chooseRequired.splice(index , 1);
      }
    }
  }

  addIndividual() {
    this.individualsCheckbox.push({
      id: Date.now().toString(36) + Math.random().toString(36).substr(2),
      approve: false,
      value: '',
      type: 'checkbox',
      answers: []
    });
  }

  addIndividualAnswers(index) {
    if (!this.individualsCheckbox[index].answers) {
      this.individualsCheckbox[index].answers = [];
    }
    this.individualsCheckbox[index].answers.push({
      id: this.individualsCheckbox[index].answers.length + 1,
      title: ''
    });
  }

  removeIndividualAnswer(indvIndex, answIndex) {
    this.individualsCheckbox[indvIndex].answers.splice(answIndex, 1);
  }

  approveIndividual(id) {
    let _index = this.individualsCheckbox.findIndex(el => el.id.toString() === id.toString());
    if (_index >= 0) {
      if (this.individualsCheckbox[_index].type === 'checkbox' || this.individualsCheckbox[_index].type === 'text') {
        if (!this.individualsCheckbox[_index].value) {
          let title = this.translateService.instant('failure');
          let msg = this.translateService.instant('event.enter_title_error');
          this.toastr.error(title, msg, {positionClass: 'toast-bottom-center'});
        } else {
          this.individualsCheckbox[_index].approve = true;
        }
      }
      if (this.individualsCheckbox[_index].type === 'radio' || this.individualsCheckbox[_index].type === 'select') {
        if (!this.individualsCheckbox[_index].value) {
          let title = this.translateService.instant('failure');
          let msg = this.translateService.instant('event.enter_title_error');
          this.toastr.error(title, msg, {positionClass: 'toast-bottom-center'});
        } else {
          let answerError = false;
          for (let i = 0; i < this.individualsCheckbox[_index].answers.length; i++) {
            if (!this.individualsCheckbox[_index].answers[i].title) {
              answerError = true;
            }
          }
          if (answerError) {
            let title = this.translateService.instant('failure');
            let msg = this.translateService.instant('event.enter_answer_error');
            this.toastr.error(title, msg, {positionClass: 'toast-bottom-center'});
            return;
          }
          if (this.individualsCheckbox[_index].answers.length < 2) {
            let title = this.translateService.instant('failure');
            let msg = this.translateService.instant('event.answer_count_error');
            this.toastr.error(title, msg, {positionClass: 'toast-bottom-center'});
            return;
          }
          this.individualsCheckbox[_index].approve = true;
        }
      }
    }
  }

  editIndividual(id) {
    let _index = this.individualsCheckbox.findIndex(el => el.id.toString() === id.toString());
    if (_index >= 0) {
      this.individualsCheckbox[_index].approve = false;
    }
  }

  removeIndividual(id) {
    let _index = this.individualsCheckbox.findIndex(el => el.id.toString() === id.toString());
    if (_index >= 0) {
      this.individualsCheckbox.splice(_index , 1);
    }
  }

  saveChanges() {
    let titleComments = {};
    this.guestsRows.forEach(el => {
      if (el && el.title) {
        let input: any = document.getElementById(el.title);
        if (input) {
          titleComments[el.title] = input.value;
        }
      }
    });
    let individual: any =  document.getElementById('individual');
    if (individual) {
      titleComments['individual'] = individual.value;
    }
    this.dialogRef.close({guestData: this.choosenIds, guestIndividual: this.individualsCheckbox, terms: this.terms,
      rules: this.rules, requiredGF: this.chooseRequired, titleComments: JSON.stringify(titleComments), freeText: this.freeText});
  }
}
